import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, UserIcon, CheckCircle2Icon } from 'lucide-react';
import { CONTACT } from '../data/modalities';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    practice: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(f => ({
    ...f,
    [key]: e.target.value
  }));
  return <section className="w-full bg-white py-16 sm:py-20" data-id="element-292" data-mp="17slhiesez2wa">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-293" data-mp="12yqy7cgq0pxq">
        <div className="max-w-2xl" data-id="element-294" data-mp="fa7r309eqj78">
          <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-295" data-mp="f9ekbzag7tp3">
            Schedule a Consultation
          </p>
          <h1 className="mt-3 font-display text-4xl font-extrabold leading-tight tracking-tight text-navy sm:text-5xl" style={{
          fontWeight: 800
        }} data-id="element-296" data-mp="a90jb179lk0k">
            Let's find the right modality for your practice
          </h1>
          <p className="mt-5 text-[16px] leading-relaxed text-charcoal/70" data-id="element-297" data-mp="1e8ab6vvkqez2">
            Tell us a little about your practice and goals. Jeff will follow up
            personally to talk through options — no pressure, no hype.
          </p>
          <a href={CONTACT.phoneHref} className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-298" data-mp="qi65miyts55f">
            <PhoneIcon className="h-[18px] w-[18px]" data-id="element-299" data-mp="26vmm28sdgycj" />
            Call {CONTACT.phone}
          </a>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_1.4fr]" data-id="element-300" data-mp="2btxzsulsft01">
          {/* Contact details */}
          <div className="rounded-3xl bg-navy p-8 text-white" data-id="element-301" data-mp="1m5iqrzjebnbt">
            <h2 className="font-display text-xl font-bold" data-id="element-302" data-mp="1h925dd3kzn2f">
              Contact JAG Medical Solutions
            </h2>
            <ul className="mt-6 space-y-5 text-sm" data-id="element-303" data-mp="1w517m740eszn">
              <li className="flex items-center gap-3" data-id="element-304" data-mp="1r6pzc0td4qjj">
                <UserIcon className="h-5 w-5 text-teal-light" data-id="element-305" data-mp="1r782lheg050y" />
                <span data-id="element-306" data-mp="13g2q9c7pnuve">{CONTACT.name}</span>
              </li>
              <li data-id="element-307" data-mp="13ej9zlm21jtm">
                <a href={CONTACT.phoneHref} className="flex items-center gap-3 transition-colors hover:text-teal-light" data-id="element-308" data-mp="yi124cvfh5d2">
                  <PhoneIcon className="h-5 w-5 text-teal-light" data-id="element-309" data-mp="1d8i7u8f3ihfr" />{' '}
                  {CONTACT.phone}
                </a>
              </li>
              <li data-id="element-310" data-mp="kpl1fiq01jfb">
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 break-all transition-colors hover:text-teal-light" data-id="element-311" data-mp="kotdmu2n8pzl">
                  <MailIcon className="h-5 w-5 shrink-0 text-teal-light" data-id="element-312" data-mp="2rdv32s3yu527" />{' '}
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-313" data-mp="2hggzvu71zcru">
                <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal-light" data-id="element-314" data-mp="2hi1rpc1zghm0" />
                <span data-id="element-315" data-mp="2mgle1dkhnvew">{CONTACT.address}</span>
              </li>
            </ul>
          </div>

          {/* Form */}
          <div className="rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_10px_40px_-20px_rgba(26,27,75,0.2)]" data-id="element-316" data-mp="3a5ntqfvkbe6r">
            {submitted ? <div className="flex h-full flex-col items-center justify-center py-10 text-center" data-id="element-317" data-mp="314pxijrd8ayq">
                <CheckCircle2Icon className="h-14 w-14 text-teal" data-id="element-318" data-mp="355ib1p79t20t" />
                <h2 className="mt-5 font-display text-2xl font-bold text-navy" data-id="element-319" data-mp="3584ebcn4ovd8">
                  Thank you
                </h2>
                <p className="mt-3 max-w-sm text-[15px] text-charcoal/65" data-id="element-320" data-mp="1tqmj51jm542b">
                  Your request has been received. Jeff will reach out shortly to
                  schedule your consultation.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-321" data-mp="255zk4lp89p06">
                <div className="grid gap-5 sm:grid-cols-2" data-id="element-322" data-mp="20995m2t2n1gv">
                  <Field label="Name" required data-id="element-323" data-mp="1v9ehu84les01">
                    <input type="text" required value={form.name} onChange={update('name')} className="w-full rounded-xl border border-slate-200 px-4 py-3 text-[15px] text-navy outline-none transition-colors focus:border-teal focus:ring-2 focus:ring-teal/20" data-id="element-324" data-mp="1vapl86u4lxqm" />
                  </Field>
                  <Field label="Email" required data-id="element-325" data-mp="2ewucm7t2hku2">
                    <input type="email" required value={form.email} onChange={update('email')} className="w-full rounded-xl border border-slate-200 px-4 py-3 text-[15px] text-navy outline-none transition-colors focus:border-teal focus:ring-2 focus:ring-teal/20" data-id="element-326" data-mp="17k220perflor" />
                  </Field>
                </div>
                <Field label="Practice name" data-id="element-327" data-mp="3o4fctolzx683">
                  <input type="text" value={form.practice} onChange={update('practice')} className="w-full rounded-xl border border-slate-200 px-4 py-3 text-[15px] text-navy outline-none transition-colors focus:border-teal focus:ring-2 focus:ring-teal/20" data-id="element-328" data-mp="3swfcdfy5lx45" />
                </Field>
                <Field label="What are you looking to accomplish?" data-id="element-329" data-mp="ap9ex4jkbfvu">
                  <textarea rows={4} value={form.message} onChange={update('message')} className="w-full resize-none rounded-xl border border-slate-200 px-4 py-3 text-[15px] text-navy outline-none transition-colors focus:border-teal focus:ring-2 focus:ring-teal/20" data-id="element-330" data-mp="fpncfsnjf7fm" />
                </Field>
                <button type="submit" className="inline-flex w-full items-center justify-center rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 sm:w-auto" data-id="element-331" data-mp="3fuo20xw70zi0">
                  Request Consultation
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}
function Field({
  label,
  required,
  children
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return <label className="block" data-id="element-332" data-mp="ccw7bbqoa1g4">
      <span className="mb-1.5 block text-[13px] font-medium text-charcoal" data-id="element-333" data-mp="cdp5hobkfimn">
        {label}
        {required && <span className="text-teal" data-id="element-334" data-mp="qd6zqj7mro3e"> *</span>}
      </span>
      {children}
    </label>;
}